import React from 'react';
import { HighlightBackgroundSC } from './common.styles';

export const HighlightBackground = ({ children, isError }) => {
  return <HighlightBackgroundSC isError={isError}>{children}</HighlightBackgroundSC>;
};
